function About() {
  return (
    <>
      <section class="py-8 bg-auto bg-image">
        <div class="container my-lg-8">
          <div class="row justify-content-center py-6">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-4 text-white fw-bold">
                  <span>About MicrofinanceBazar</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item lead">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active lead text-white"
                    aria-current="page"
                  >
                    About Us
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-7">
        <div className="container">
          <h1 class="fw-bold mb-2">
            <u class="text-primary">
              <span class="text-dark">About Us</span>
            </u>
          </h1>
          <p className="lead lh-sm text-dark">
            Established in the year 2025, Microfinancebazar is created to
            address the critical need for safeguarding public interests,
            especially as microfinance priorities are projected by SDG goals by
            2030. Our strategy is centred on achieving meaningful financial
            outcomes. We aspire to surpass our own targets by fostering
            large-scale social impact, leveraging our value chain, and
            collaborating with various stakeholders within the global
            microfinance landscape.
            <br />
            <br />
            We empower small and micro-business owners, as well as farmers with
            limited resources, to access funding for the expansion of their
            businesses. Our collaborators offer education, healthcare, and
            essential services to families in need.
            <br />
            <br />
            Our decision-making framework incorporates artificial intelligence
            techniques that determine the most effective lending actions,
            minimizing expected losses for lenders and taxpayers, which
            establishes Microfinancebazar as a frontrunner in the microfinance
            FinTech industry.
          </p>

          <h1 class="fw-bold mb-2">
            The{" "}
            <u class="text-primary">
              <span class="text-dark">Team</span>
            </u>
          </h1>
          <p className="lead lh-sm text-dark">
            Engaging in several notable projects in the realm of
            micro-entrepreneurship has been a gratifying experience, with many
            ventures starting from straightforward ideas and developing into
            profitable businesses in India and worldwide. <br />
            <br />
            We at Microfinancebazar understand the significant impact of every
            stakeholder in constructing the future of the Microfinancebazar
            through online microfinance platform.
          </p>

          <h1 class="fw-bold mb-2">
            Our{" "}
            <u class="text-primary">
              <span class="text-dark">Approach</span>
            </u>
          </h1>
          <p className="lead lh-sm text-danger mb-1">
            A new business environment needs new thinking.
          </p>
          <p className="lead lh-sm text-dark">
            Microfinancebazar places significant emphasis on the middle child
            "S" of ESG, highlighting its role as a key focus. Throughout the
            past year, there has been a growing emphasis on financial inclusion
            as a crucial approach to enhancing people's livelihoods, diminishing
            poverty, and driving economic development in response to the
            challenges posed by the COVID-19 pandemic.
          </p>
          <p className="lead lh-sm text-dark">
            The Microfinancebazar team is actively aligning their business
            strategies with international standards, ensuring the integrity of
            their assets and promoting transparency in ESG-related disclosures.
            Furthermore, the Microfinancebazar ESG community is collaboratively
            addressing impact measurement and communication to build trust among
            diverse stakeholders.
          </p>
        </div>
      </section>
    </>
  );
}

export default About;
